import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Card, Col, Row } from "reactstrap";
import {
  getGlobalSettings,
  updateGlobalSettings,
} from "../../actions/globalSettingAction";
import { GlobalSettings, requestHasError } from "../../utils";
import Spinner from "../Common/Spinner";
// eslint-disable-next-line import/no-unresolved
import OilTypeMaster from "./OilTypeMaster";

const GlobalSettingsView = ({ dispatch }) => {
  const [data, setData] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(getGlobalSettings(GlobalSettings.RequireUrgentJobPhoto)).then(
      (x) => {
        setLoading(false);
        if (!requestHasError({ x })) {
          setData({ ...x.data, value: x.data.value === "true" });
        }
      }
    );
  }, []);
  const handleSettingsChange = () => {
    setData({ ...data, value: !data.value });
  };
  const handleSave = () => {
    setSaveLoading(true);
    const payload = {
      name: data.name,
      value: `${data.value}`,
    };
    dispatch(updateGlobalSettings(payload)).then((x) => {
      setSaveLoading(false);
      if (!requestHasError({ x })) {
        toastr.success("Global settings updated.");
      }
    });
  };
  return (
    <div className="mb-1">
      <div className={"row"}>
        <div className={"col-12"} style={{ marginBottom: "24px" }}>
          <h4>Global Settings</h4>
        </div>
      </div>
      <Row>
        <Col lg={6} sm={12} md={8}>
          <Card className="p-1">
            {loading ? (
              <div className="flex justify-content-center align-items-center">
                <Spinner size="small" />
              </div>
            ) : (
              <React.Fragment>
                <Row>
                  <Col lg={6} sm={8} md={9}>
                    <label>
                      Require drivers to upload photos for urgent run
                    </label>
                  </Col>
                  <Col lg={6} sm={4} md={3}>
                    <label className="switch switch-3d switch-success">
                      <input
                        type="checkbox"
                        checked={data.value}
                        className="switch-input"
                        onChange={(e) => handleSettingsChange(e)}
                      />
                      <span className="switch-label" />
                      <span className="switch-handle" />
                    </label>
                  </Col>
                </Row>
                <div className="mt-2">
                  <button
                    className={`btn btn-primary ${
                      saveLoading ? "no-pointer-events" : ""
                    }`}
                    onClick={handleSave}
                  >
                    <i className="fa fa-floppy-o" aria-hidden="true"></i> &nbsp;
                    {saveLoading ? "Saving" : "Save"}
                  </button>
                </div>
              </React.Fragment>
            )}
          </Card>
        </Col>
      </Row>

      <OilTypeMaster />
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    getGlobalSettings,
  };
}

export default connect(null, mapDispatchToProps)(GlobalSettingsView);
